import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AboutModal } from '../../modals/global/AboutModal/AboutModal';
import '../styles/About.css';

const About = () => {
  const { headerContent, sections } = AboutModal;

  const getImageSrc = (imageName) => {
    try {
      return require(`../../images/Test_images/${imageName}`);
    } catch (error) {
      console.warn(`Image not found: ${imageName}`);
      return 'https://via.placeholder.com/300x200?text=Image+Not+Found'; // Placeholder image
    }
  };

  return (
    <Container className="py-5">
      <section className="py-4"><br></br>
        <div className="container">
          {/* Hero Header Section */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-xl-10">
              <h2 className="pricing-header">Ratibu Shughuli Yako Kirahisi na Kwa njia ya Kisasa</h2>
              <p className="about-hero-desc">{headerContent.description}</p>
            </div>
          </div>

          {/* Cards Section */}
          <div className="row gy-4 mt-2">
            {sections.map(section => (
              <div key={section.id} className="col-md-4">
                <div className="about-card">
                  <div className="about-card-img-wrapper">
                    <img
                      src={getImageSrc(section.image)}
                      alt={section.title}
                      className="about-card-img"
                    />
                  </div>
                  <h3 className="about-card-title">
                    <Link to={section.link} className="about-card-link text-decoration-none">
                      {section.title}
                    </Link>
                  </h3>
                  <p className="about-card-desc">{section.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA Footer Section */}
          <div className="d-flex justify-content-center about-cta-container">
            <Link to="/login">
              <Button className="about-cta-btn">
                Jisajili Sasa
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Container>
  );
};

export default About;
